import { render, staticRenderFns } from "./ContactOthers.vue?vue&type=template&id=cbe162a2&scoped=true&"
import script from "./ContactOthers.vue?vue&type=script&lang=ts&"
export * from "./ContactOthers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe162a2",
  null
  
)

export default component.exports